var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_347",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 32,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.64H37.8519V41.7778H6V14.64Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4841 34.4861V25.8134C25.4841 23.5715 27.2202 21.7535 29.362 21.7535H37.8461V19.6861C37.8461 16.9129 35.6968 14.6638 33.048 14.6638H10.798C8.14902 14.6638 6 16.9129 6 19.6863V30.4172C6 33.1904 8.14902 35.4401 10.798 35.4401H14.4696V41.3695C14.4696 41.6968 14.919 41.9274 15.1522 41.6528C16.9016 39.5819 18.6499 37.5113 20.3999 35.4404H25.5961C25.5249 35.1331 25.4841 34.8154 25.4841 34.4861Z",
    fill: "#00477A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6855 27.2434V36.9248C27.6855 38.9462 29.2518 40.5859 31.1841 40.5859H40.4052C41.6809 42.0958 42.9552 43.605 44.2307 45.1146C44.4005 45.3163 44.7278 45.1473 44.7278 44.9091V40.5859H50.5018C52.4338 40.5859 54.0001 38.9462 54.0001 36.9248V27.2434C54.0001 25.2214 52.4338 23.581 50.5018 23.581H31.1841C29.2518 23.581 27.6855 25.2208 27.6855 27.2434Z",
    fill: "#00477A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.8b597bf7c5343e6024c029b4b16b04ff.svg";
export { ForwardRef as ReactComponent };